import { IApplicationState } from '../../types/redux';

/* istanbul ignore next */
export function selectOnboardingCookieState(state: IApplicationState): boolean {
  return state.cookies.onboarding;
}
